import React from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { XCircle, ArrowRight } from "lucide-react";

const PaymentCancel = () => {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const appId = params.get("app");
  const goToApp = () => navigate(appId ? `/applications/${appId}` : "/dashboard");

  return (
    <div className="wechr-section">
      <div className="wechr-container flex justify-center">
        <Card className="w-full max-w-lg" data-testid="payment-cancel-card">
          <CardContent className="flex flex-col items-center gap-4 py-12 text-center">
            <div className="flex h-16 w-16 items-center justify-center rounded-2xl bg-[var(--wechr-subtle)]"><XCircle className="h-8 w-8 text-navy-700" /></div>
            <h1 className="font-heading text-xl font-semibold text-navy-900" data-testid="payment-cancel-title">Payment cancelled</h1>
            <p className="max-w-sm text-sm text-[var(--wechr-muted-text)]">No payment was taken. Your application is saved — you can complete payment whenever you're ready to begin the review.</p>
            <Button className="btn-green" onClick={goToApp} data-testid="payment-cancel-continue">Return to application <ArrowRight className="ml-1 h-4 w-4" /></Button>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default PaymentCancel;
